var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header-wrapper" };
const _hoisted_2 = { class: "header-wrapper__header controls" };
const _hoisted_3 = { class: "left breadcrumbs-wrapper" };
const _hoisted_4 = { class: "breadcrumbs" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("a", { href: "/account-rewards" }, "Rewards")
], -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-angle-right",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
const _hoisted_7 = { class: "js-heading" };
const _hoisted_8 = { class: "right" };
const _hoisted_9 = { class: "header-wrapper__sub-header" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("th", null, "Name", -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("th", null, "Value Type", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("th", null, "Last Updated", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("th", null, null, -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "table-no-data" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "No rewards have been configured.")
], -1 /* HOISTED */);
import Table from "src/shared/v-components/ui/table/Table.vue";
import IntegrationRewardSupplierListItem from "./IntegrationRewardSupplierListItem.vue";
import { useRewardSupplierResultSet, } from "src/shared/store/reward/supplier/composables";
import Strings from "src/shared/Strings";
import NotificationFlash from "src/shared/v-components/ui/NotificationFlash.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useRewardSupplierStore } from "src/shared/store/reward/supplier";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import CreateIntegrationSupplierButton from "src/account-rewards/v-components/reward-suppliers-list/CreateIntegrationSupplierButton.vue";
import Backbone from "backbone";
import { extend } from "lodash";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntegrationRewardSupplierList',
    props: {
        displayType: {}
    },
    setup(__props) {
        const props = __props;
        const store = useRewardSupplierStore();
        const eventBus = extend({}, Backbone.Events);
        const parameters = ref({
            currentPageNumber: 1,
            limit: 1000,
            include_archived: false,
            include_disabled: true,
        });
        const results = useRewardSupplierResultSet(parameters, eventBus);
        const filteredRewardSuppliers = computed(() => {
            return results.results.filter((rewardSupplier) => {
                return (Strings.capitalize(rewardSupplier.display_type) ===
                    Strings.capitalize(props.displayType) && rewardSupplier.enabled);
            });
        });
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            document.title = `${Strings.capitalize(props.displayType)}`;
            yield store.fetchRewardSupplierDisplayTypes();
            const displayTypes = store
                .listAllRewardSupplierDisplayTypes()
                .map((item) => Strings.capitalize(item));
            if (!displayTypes.includes(Strings.capitalize(props.displayType))) {
                window.location.href = "/account-rewards";
            }
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("ul", _hoisted_4, [
                                _hoisted_5,
                                _hoisted_6,
                                _createElementVNode("li", null, [
                                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(Strings).capitalize(_ctx.displayType)), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(CreateIntegrationSupplierButton, {
                                "display-type": _ctx.displayType,
                                "event-bus": _unref(eventBus)
                            }, null, 8 /* PROPS */, ["display-type", "event-bus"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", null, "Manage your " + _toDisplayString(_unref(Strings).capitalize(_ctx.displayType)), 1 /* TEXT */)
                    ])
                ]),
                (_unref(results).isLoading)
                    ? (_openBlock(), _createBlock(NotificationFlash, { key: 0 }))
                    : _createCommentVNode("v-if", true),
                (_unref(results).results.length > 0)
                    ? (_openBlock(), _createBlock(Table, {
                        key: 1,
                        isLoading: false,
                        isEmpty: _unref(results).results.length === 0
                    }, {
                        thead: _withCtx(() => [
                            _createElementVNode("tr", null, [
                                _hoisted_10,
                                _hoisted_11,
                                _createElementVNode("th", null, [
                                    _createVNode(Tooltip, { message: "The number of rewards that have been earned by consumers but have not been fulfilled." }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("Unfulfilled Rewards")
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("th", null, [
                                    _createVNode(Tooltip, { message: "The number of rewards that have been fulfilled to consumers." }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("Fulfilled rewards")
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _hoisted_12,
                                _hoisted_13
                            ])
                        ]),
                        tbody: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRewardSuppliers.value, (rewardSupplier) => {
                                return (_openBlock(), _createBlock(IntegrationRewardSupplierListItem, {
                                    key: rewardSupplier.id,
                                    rewardSupplier: rewardSupplier,
                                    eventBus: _unref(eventBus)
                                }, null, 8 /* PROPS */, ["rewardSupplier", "eventBus"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        empty: _withCtx(() => [
                            _hoisted_14
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["isEmpty"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
